/**
 * Which scroll milestones (10, 20, … 100 % of the lesson height) a learner has reached for the first time in this
 * visit (spec docs/compound-v/specs/2026-10-26-course-student-analytics.md §Мои решения «Прокрутка»). Pure.
 */

export const MARKS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100] as const;

export interface ScrollGeometry {
  /** window.scrollY */
  scrollTop: number;
  /** window.innerHeight */
  viewportHeight: number;
  /** Top of the lesson content in page coordinates (element top + scrollY). */
  contentTop: number;
  /** Height of the lesson content in px. */
  contentHeight: number;
}

/**
 * Seen share = (scrollTop + viewportHeight − contentTop) / contentHeight, clamped to 0..1. A lesson whose bottom
 * is already on screen (seen share ≥ 1) reaches every mark up to 100. contentHeight ≤ 0 → no marks.
 * Returns, in ascending order, every mark m with m ≤ seen share × 100 that is not in `already`.
 * Example: scrollTop 0, viewport 800, contentTop 0, height 1600 → seen 0.5 → [10, 20, 30, 40, 50].
 */
export function newMarks(g: ScrollGeometry, already: ReadonlySet<number>): number[] {
  if (g.contentHeight <= 0) return [];
  const seen = Math.min(1, Math.max(0, (g.scrollTop + g.viewportHeight - g.contentTop) / g.contentHeight));
  const reached = seen * 100;
  return MARKS.filter((m) => m <= reached && !already.has(m));
}
